"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sleep = exports.generateRunId = void 0;
function generateRunId(...args) {
    return `${Date.now()}-${args.join('-')}`;
}
exports.generateRunId = generateRunId;
function sleep(milliseconds) {
    return new Promise(resolve => {
        setTimeout(resolve, milliseconds);
    });
}
exports.sleep = sleep;
